import styled from 'styled-components'

export const Select = styled.div<{
  type: string
}>`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${(props) => props.type === 'filter' && 'font-size: 12px;'}

  @media (min-width: 1200px) {
    ${(props) => props.type === 'filter' && 'font-size: 14px;'}
  }

  label {
    padding: 3px 0;
  }

  .MuiTextField-root {
    display: flex;
    margin-top: 3px;
    min-width: 150px;
    ${(props) => props.type === 'default' && 'max-width: 200px;'}

    .MuiInputBase-root {
      border-radius: 0;
      font-weight: 500;
      ${(props) => props.type === 'filter' && 'font-size: 12px;'}

      @media (min-width: 1200px) {
        ${(props) => props.type === 'filter' && 'font-size: 14px;'}
      }

      .MuiInputBase-input {
        ${(props) => props.type === 'filter' && 'padding-top: 8px;'}
        ${(props) => props.type === 'filter' && 'padding-bottom: 8px;'}
      }
    }
  }
`
